export default "__VITE_ASSET__BdhbVzih__"